import { PipelineResponse } from '../../types/pipeline';
import { PipelineStatus } from '../enums';

const NUMBER_OF_PIPELINES_TO_TEST = 5;

const isValidHttpUrl = (string) => {
    let url;

    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }

    return url.protocol === 'http:' || url.protocol === 'https:';
};

export const transformPipelineResponseToIntermediateFSNModel = (data: PipelineResponse[], activePartner: string) => {
    const groupedData = data.reduce((acc, item) => {
        acc[item.uniqueId] = acc[item.uniqueId] || [];
        acc[item.uniqueId].push(item);
        return acc;
    }, {});

    const result = Object.keys(groupedData).map((uniqueId) => {
        const pipelines = groupedData[uniqueId].reduce((acc, item) => {
            acc[item.pipelineId] = item.status;
            return acc;
        }, {});

        const isPipelinesStatusCompleted = Object.values(pipelines).every((status) => status === PipelineStatus.COMPLETED);
        let l2compressedModelUrl: string | null = null;

        if (pipelines.assestCompression === 'COMPLETED') {
            const message = groupedData[uniqueId].find((item) => item.pipelineId === 'assestCompression').message;
            const l2compressedModelpublicUrl = JSON.parse(message).l2compressedModelpublicUrl.urls;
            const lastL2ModelUrl = l2compressedModelpublicUrl[l2compressedModelpublicUrl.length - 1];
            const output = lastL2ModelUrl.split('/').pop();
            l2compressedModelUrl = lastL2ModelUrl;
        }

        let fitFor3DInPP = undefined;
        let fit = true;
        let error = { message: '', stage: '' };

        if (pipelines.assetVlidationPipeline||pipelines.assetValidationPipeline) {
            const message = groupedData[uniqueId].find((item) => (item.pipelineId === 'assetVlidationPipeline'||item.pipelineId === 'assetValidationPipeline')).message;
            const jsonParsedMessage = JSON.parse(message);
            fitFor3DInPP = jsonParsedMessage.fitFor3DInPP ?? undefined;
            fit = jsonParsedMessage.fit;
        }

        const isPipelinesCompleted = Object.keys(pipelines).length === NUMBER_OF_PIPELINES_TO_TEST && isPipelinesStatusCompleted && fit;
        const somePipelineFailed = Object.keys(pipelines).some((item) => pipelines[item] === PipelineStatus.FAILED);

        if (data.length) {
            if (somePipelineFailed) {
                const failedKey = data.find((item) => item?.status === PipelineStatus.FAILED)?.pipelineId;
                const failedPipeline = groupedData[uniqueId].find((item) => item.pipelineId === failedKey);
                error.stage = failedPipeline.pipelineId;

                if (failedPipeline.message) {
                    const message = failedPipeline.message;
                    error.message = message;
                } else {
                    error.message = 'failed on upload';
                }
            } else if ((pipelines.assetVlidationPipeline||pipelines.assetValidationPipeline) && fitFor3DInPP === false) {
                error = {
                    message: 'failed on fitFor3DInPP',
                    stage: 'fitFor3DInPP'
                };
            }
        }

        const status = somePipelineFailed || !fit ? PipelineStatus.FAILED : isPipelinesCompleted ? PipelineStatus.COMPLETED : PipelineStatus.PENDING;

        return {
            uniqueId,
            status,
            pipelines,
            fitFor3DInPP,
            error,
            url: l2compressedModelUrl
        };
    });

    return result;
};
